import type { ReviewQueueResult, ReviewSessionResult, SrsRating, WordRecordView } from '@en3/shared';
import { api } from './client';
import { toQuery } from './content.api';

/**
 * 复习接口（阶段 4）。
 *
 * 交互上的一个重要决定：**评分只存在前端内存里，会话结束时一次性提交**。
 * 原因有两个：
 * 1. 每张卡一次网络往返会让"连续刷卡"变得很卡（移动网络下尤其明显）；
 * 2. 复习中途退出时，未提交的卡不会被写进 `review_logs` —— 也就是"没答完不算数"，
 *    这比"答了一半留下半截调度状态"更符合用户预期。
 * 代价是提交失败会丢一次会话的进度，因此 `ReviewPage` 在失败时必须提示并允许重试。
 */

export interface ReviewSubmitItem {
  recordId: string;
  rating: SrsRating;
  elapsedMs?: number;
}

export const reviewApi = {
  queue: (params: { limit?: number; mode?: 'due' | 'mixed'; articleId?: string } = {}) =>
    api.get<ReviewQueueResult>(`/api/review/queue${toQuery(params)}`),

  submit: (items: ReviewSubmitItem[]) => api.post<ReviewSessionResult>('/api/review', { items }),

  reset: (recordId: string) => api.post<{ record: WordRecordView }>('/api/review/reset', { recordId }),
};
